import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { ComboBoxContext } from "./ComboBoxContext";
import styled from 'styled-components';
import { theme } from "../../theme";
export function ComboBoxInlineList(_ref) {
  var children = _ref.children,
      other = _objectWithoutProperties(_ref, ["children"]);

  var context = React.useContext(ComboBoxContext);

  if (!context) {
    throw new Error('ComboBoxList must be wrapped in a ComboBox component');
  }

  var getMenuProps = context.getMenuProps;
  return /*#__PURE__*/React.createElement(StyledInlineList, _extends({}, other, getMenuProps()), children);
}
var StyledInlineList = styled.div.withConfig({
  displayName: "ComboBoxInlineList__StyledInlineList",
  componentId: "vapor__rcz2iy-0"
})(["padding:0 ", ";overflow-y:scroll;height:100%;"], theme.spaces[8]);